import {removeSpecialCharacters} from "../../../../utils/string-helpers";

export class GameVendorDefinition {
    constructor(public readonly id: number,
        public readonly name: string,
        public readonly tags?: string[]) {
    }

    isMatch(regEx: RegExp): boolean {
        return this._nameIsMatch(regEx) || this._anyTagIsMatch(regEx);
    }

    private _nameIsMatch(regEx: RegExp): boolean {
        return Boolean(removeSpecialCharacters(this.name).match(regEx));
    }

    private _anyTagIsMatch(regEx: RegExp): boolean {
        return this.tags?.reduce((prevResult, currentTag) => {
            if (Boolean(removeSpecialCharacters(currentTag).match(regEx))) {
                return true;
            }
            return prevResult;
        }, false);
    }
}